<script setup lang="ts">
import { RouterView } from 'vue-router'
import {useHead} from "@unhead/vue";

const head = useHead({
  title: "Bisa Besar"
})
</script>

<template>
  <RouterView />
</template>

<style scoped>
</style>
